'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PreferencesDropDownMenu = require('./PreferencesDropDownMenu');

var _PreferencesDropDownMenu2 = _interopRequireDefault(_PreferencesDropDownMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CcdTopBar = function (_Component) {
  _inherits(CcdTopBar, _Component);

  function CcdTopBar() {
    _classCallCheck(this, CcdTopBar);

    return _possibleConstructorReturn(this, (CcdTopBar.__proto__ || Object.getPrototypeOf(CcdTopBar)).apply(this, arguments));
  }

  _createClass(CcdTopBar, [{
    key: 'render',
    value: function render() {
      //"navbar navbar-default navbar-fixed-top ccdTopBar dropShadow">
      return _react2.default.createElement(
        'nav',
        { className: 'ccdTopBar dropShadow' },
        _react2.default.createElement(
          'div',
          { className: 'alignleft' },
          _react2.default.createElement(_PreferencesDropDownMenu2.default, { sectionsArray: this.props.sectionsArray,
            moveSectionCB: this.props.moveSectionCB,
            toggleVisibleCB: this.props.toggleVisibleCB,
            resetFilterCB: this.props.resetFilterCB,
            saveUserPreferencesCB: this.props.saveUserPreferencesCB,
            scrollToSectionCB: this.props.scrollToSectionCB
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'alignright no-wrap' },
          _react2.default.createElement(
            'button',
            { className: 'ccd-btn btn-rectangle', type: 'button', title: 'Expand All', onClick: function () {
                this.props.toggleCollapseCB(false, null);
              }.bind(this) },
            _react2.default.createElement('img', { className: 'verticalAlign', src: require('../resources/icons/CCD-Icon-22.png'), alt: 'Expand All', width: '30', height: '30' }),
            _react2.default.createElement(
              'span',
              { className: 'indent-15 hideOnMediumScreen' },
              'Expand All'
            )
          ),
          _react2.default.createElement(
            'button',
            { className: 'ccd-btn btn-rectangle', type: 'button', title: 'Collapse All', onClick: function () {
                this.props.toggleCollapseCB(true, null);
              }.bind(this) },
            _react2.default.createElement('img', { className: 'verticalAlign', src: require('../resources/icons/CCD-Icon-23.png'), alt: 'Collapse All', width: '30', height: '30' }),
            _react2.default.createElement(
              'span',
              { className: 'indent-15 hideOnMediumScreen' },
              'Collapse All'
            )
          ),
          _react2.default.createElement(
            'button',
            { className: 'ccd-btn btn-rectangle', type: 'button', title: 'Print CCD', onClick: function () {
                this.props.printCB();
              }.bind(this) },
            _react2.default.createElement('img', { className: 'verticalAlign', src: require('../resources/icons/CCD-Icon-26.png'), alt: 'Print CCD', width: '30', height: '30' }),
            _react2.default.createElement(
              'span',
              { className: 'indent-15 hideOnMediumScreen' },
              'Print'
            )
          )
        )
      );
    }
  }]);

  return CcdTopBar;
}(_react.Component);

CcdTopBar.propTypes = {
  sectionsArray: _propTypes2.default.array,
  saveUserPreferencesCB: _propTypes2.default.func,
  toggleVisibleCB: _propTypes2.default.func,
  moveSectionCB: _propTypes2.default.func,
  resetFilterCB: _propTypes2.default.func,
  toggleCollapseCB: _propTypes2.default.func,
  printCB: _propTypes2.default.func,
  scrollToSectionCB: _propTypes2.default.func
};

exports.default = CcdTopBar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/updox-care-record-viewer/lib/reactComponents/CcdTopBar.js
// module id = 1235
// module chunks = 0